import React from "react";
import { motion } from "framer-motion";

const WhatIsService = ({ title, description }) => {
  const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, when: "beforeChildren", staggerChildren: 0.3 },
    },
  };

  // Variants for title and description
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <motion.section
      className="info-top"
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }} 
    >
      <div className="info-top-inner">
        {title && (
          <motion.h2 className="section-title" variants={itemVariants}>
            {title}
          </motion.h2>
        )}
        {description && (
          <motion.p variants={itemVariants}>{description}</motion.p>
        )}
      </div>
    </motion.section>
  );
};

export default WhatIsService;
